import * as React from 'react';
import { SerializedStyles } from '@emotion/core';
import RaterApprovalLayout from '../raterApproval/RaterApprovalLayout';
import ReportRecipientLayout from '../reportRecipient/ReportRecipientLayout';
import ProjectLayout from '../project/ProjectLayout';
import { PortalType } from '../navigation/portalType';
import { usePortalType } from '../auth/hooks';
import CollaboratorLayout from '../project/devPlan/collaboration/CollaboratorLayout';


type Props = {
  children: React.ReactNode;
  floatMenu?: boolean;
  className?: string;
  contentStyle?: SerializedStyles;
}


const renderLayout = (props: Props, portalType?: PortalType) => {
  switch (portalType) {
    case PortalType.RATER_APPROVAL:
      return (
        <RaterApprovalLayout {...props}>
          {props.children}
        </RaterApprovalLayout>
      );
    case PortalType.REPORT_RECIPIENT:
      return (
        <ReportRecipientLayout {...props}>
          {props.children}
        </ReportRecipientLayout>
      );
    case PortalType.COLLABORATOR:
      return (
        <CollaboratorLayout {...props}>
          {props.children}
        </CollaboratorLayout>
      );
    default:
      return (
        <ProjectLayout {...props}>
          {props.children}
        </ProjectLayout>
      );
  }
};


/**
 * PortalAutoLayout: a component that sets the proper page layout based on which portal the user is currently logged in
 * to.
 *
 * PureComponent: true
 * Redux Connected: false
 */
const PortalAutoLayout: React.FC<Props> = props => {
  const portalType = usePortalType();

  return (
    <>
      {renderLayout(props, portalType)}
    </>
  );
};

export default PortalAutoLayout;
